import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import useEvalRunConfigExpectedEventForm from "./useEvalRunConfigExpectedEventForm";
import EvalRunConfigExpectedEventForm from "./EvalRunConfigExpectedEventForm";

export default EvalRunConfigExpectedEventFormDialog;

function EvalRunConfigExpectedEventFormDialog(props) {
  const {
    onClose,
    onConfirm,
    confirmCtaLabel,
    title,
    personaOptions,
    eventsToTrackOptions,
    expectedEvent,
  } = props;

  const { formState, updateFormState, errors, validate } =
    useEvalRunConfigExpectedEventForm(expectedEvent);

  const handleConfirm = () => {
    if (!validate()) return;

    onConfirm(formState);
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <EvalRunConfigExpectedEventForm
          errors={errors}
          formState={formState}
          updateFormState={updateFormState}
          personaOptions={personaOptions}
          eventsToTrackOptions={eventsToTrackOptions}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handleConfirm}>{confirmCtaLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}
